jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
    updateCartCount();
    if (typeof window.tfcOpenCartSidebar === 'function') {
        window.tfcOpenCartSidebar();
    }
});

function updateCartCount() {
    jQuery.ajax({
        url: wc_add_to_cart_params.ajax_url, 
        type: 'POST',
        data: {
            action: 'get_cart_count', 
        },
        success: function(response) {
            if (response.success && response.data.cart_count !== undefined) {
                jQuery('.cart-count').text(response.data.cart_count);
            }
        }
    });
}

// Global: tfc-product-modal.js calls updateCartCount() after adding to the basket.
window.updateCartCount = updateCartCount;
